const userData = JSON.parse(
  localStorage.getItem("user_info") ? localStorage.getItem("user_info") : "{}"
);

export const HOME_URL = "dashboard";

////////////////// auth start///////////////////
export const LOGIN = "/login";
export const FORGOT_PASSWORD = "/forgot-password";
export const EDIT_PROFILE = `edit-profile`;
export const VIEW_PROFILE = "view-profile";
export const NEW_PASSWORD = "/auth/password/:uid/:token";
export const PREFERENCE = `preference`;

////////////////// auth end///////////////////

////////////////// category start///////////////////
export const LIST_CATEGORY = `category-list`;
export const ADD_CATEGORY = `add-category`;
export const EDIT_CATEGORY = `edit-category`;
////////////////// category end/////////////////////

////////////////// material start///////////////////
export const LIST_MATERIAL = `material-list`;
export const ADD_MATERIAL = `add-material`;
export const EDIT_MATERIAL = `edit-material`;
////////////////// material end/////////////////////

//////////////////// material Group start///////////////////
export const LIST_MATERIAL_GROUP = `material-group-list`;
export const ADD_MATERIAL_GROUP = `material-group-add`;
export const EDIT_MATERIAL_GROUP = `material-group-edit`;
////////////////// material Group end/////////////////////

////////////////// museum start///////////////////
export const LIST_MUSEUM = `museum-list`;
export const ADD_MUSEUM = `add-museum`;
export const EDIT_MUSEUM = `edit-museum`;
////////////////// museum end/////////////////////

////////////////// roles start///////////////////
export const LIST_ROLES = `roles-list`;
export const ADD_ROLES = `add-roles`;
export const EDIT_ROLES = `edit-roles`;
////////////////// roles end/////////////////////

////////////////// group start///////////////////
export const LIST_GROUP = `group-list`;
export const ADD_GROUP = `add-group`;
export const EDIT_GROUP = `edit-group`;
////////////////// group end/////////////////////

////////////////// user start///////////////////
export const LIST_USER = `user-list`;
export const ADD_USER = `add-user`;
export const EDIT_USER = `edit-user`;
////////////////// user end/////////////////////

////////////////// object start///////////////////
// export const LIST_OBJECT = `object-list`
export const LIST_OBJECT = "object-list";
export const ADD_OBJECT = `object-add`;
export const EDIT_OBJECT = `edit-object`;
export const ADMIN_DETAIL = `admin-detail`;
export const BULK_ACCESSION = `bulk-accession`;
export const OBJECT_PIN = "object-pin";
////////////////// object end/////////////////////

////////////////// Building start///////////////////
export const LIST_BUILDING = `building-list`;
export const ADD_BUILDING = `building-add`;
export const EDIT_BUILDING = `edit-building`;
////////////////// Building end/////////////////////

////////////////// floor start///////////////////
export const LIST_FLOOR = `floor-list`;
export const ADD_FLOOR = `floor-add`;
export const EDIT_FLOOR = `edit-floor`;
////////////////// floor end/////////////////////

////////////////// room start///////////////////
export const LIST_ROOM = `room-list`;
export const ADD_ROOM = `room-add`;
export const EDIT_ROOM = `edit-room`;
////////////////// room end/////////////////////

////////////////// shelf start///////////////////
export const LIST_SHELF = `storage-system-list`;
export const ADD_SHELF = `storage-system-add`;
export const EDIT_SHELF = `edit-storage-system`;
////////////////// shelf end/////////////////////

////////////////// rack start///////////////////
export const LIST_RACK = `storage-unit-list`;
export const ADD_RACK = `storage-unit-add`;
export const EDIT_RACK = `edit-storage-unit`;
////////////////// rack end/////////////////////

////////////////// storage-type start///////////////////
export const LIST_STORAGE = `storage-type-list`;
export const ADD_STORAGE = `storage-type-add`;
export const EDIT_STORAGE = `edit-storage-type`;
////////////////// storage-type end/////////////////////

////////////////// unit-type start///////////////////
export const LIST_UNIT = `unit-type-list`;
export const ADD_UNIT = `unit-type-add`;
export const EDIT_UNIT = `edit-unit-type`;
////////////////// unit-type end/////////////////////

////////////////// loacation start///////////////////
export const LIST_LOCATION = `location-list`;
export const ADD_LOCATION = `location-add`;
export const EDIT_LOCATION = `edit-location`;
////////////////// location end///////////////////

/////////////////////Notification start/////////////////////

export const lIST_NOTIFICATION = `notification`;

/////////////////////Notification end///////////////////////

////////////////photography list////////////////////
export const EDIT_PHOTOGRAPHY = `edit-photography`;
export const LIST_PHOTOGRAPHY = "list-photography";
export const KANBAN_BOARD = "digital-kanban-board";
export const FILE_URL = "file-url";
////////////////photography list////////////////////

////////////////conservation list start////////////////////
export const LIST_CONSERVATION = "list-conservation";
export const ADD_CONSERVATION = "add-conservation";
export const CONSERVATION_KANBAN = "conservation-kanban-board";
////////////////conservation list end////////////////////

////////////////////activity log start///////////////////////////////////
export const ACTIVITY_LOG_LIST = "activity-log-list";
////////////////////activity log end////////////////////////////////////

////////////////////support start///////////////////////////////////
export const RELEASE_NOTE = "release-notes";
export const HELP_CENTER = "help-and-support";
////////////////////support end///////////////////////////////////

////////////////////transit start///////////////////////////////////
export const TRANSIT_FORM_LIST = "transit-list";
export const TRNSIT_OBJECT_LIST = "transit-object-list";
export const TRANSIT_INNER_LIST = "add-transit";
export const TRANSIT_EDIT = "edit-transit";
////////////////////transit end///////////////////////////////////

export const GLOBAL_SEARCH = "global-search";
///////////////Qr-code location managment//////////////////////////////
export const QR_LOCATION_MANAGMENT = `qr-location-managment`;
///////////////Qr-code location managment//////////////////////////////

///////////////Object Admin details//////////////////////////////
export const ADMIN_DETAILS = `Object-Admin_details`;
///////////////Object Admin details//////////////////////////////

///////////////Curator Admin details//////////////////////////////
export const EXHIBITION_LIST = "exhibition-list";
export const EXHIBITION_ADD = "exhibition-add";
export const EXHIBITION_EDIT = "exhibition-edit";
///////////////Curator Admin details//////////////////////////////
